import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@cloudscape-design/global-styles/index.css'
import { applyMode, Mode } from '@cloudscape-design/global-styles'
import { App } from './App'

const VISUAL_MODE_KEY = 'bedrock-diag-visual-mode'
const stored = localStorage.getItem(VISUAL_MODE_KEY)
applyMode(stored === 'light' ? Mode.Light : Mode.Dark)

const root = document.getElementById('root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
